<template>
  <div class="picker-modal-button" @click="show"><slot></slot></div>
</template>

<script>
export default {
  props: ['options'],
  methods: {
    show () {
      let modal = document.createElement('div')
      modal.setAttribute('class', 'picker-modal')
      modal.onclick = function (event) {
        document.body.removeChild(modal)
      }
      for (var i = 0; i < this.options.length; i++) {
        let opt = document.createElement('div')
        opt.setAttribute('class', 'picker-modal-option')
        opt.innerText = this.options[i]
        opt.onclick = (event) => {
          this.$emit('select', event.target.innerText)
        }
        modal.appendChild(opt)
      }
      document.body.appendChild(modal)
    }
  }
}
</script>

<style lang="less">
.picker-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgba(0,0,0,0.5);
  
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 10%;
}
.picker-modal-option {
  background-color: white;
  color: black;
  padding-top: 1em;
  padding-bottom: 1em;
  outline: 1px solid black;
  width: 100%;
  text-align: center;
}
</style>